import { render, staticRenderFns } from "./page-loader-quotes.vue?vue&type=template&id=9a53db7e&scoped=true&"
import script from "./page-loader-quotes.vue?vue&type=script&lang=js&"
export * from "./page-loader-quotes.vue?vue&type=script&lang=js&"
import style0 from "./page-loader-quotes.vue?vue&type=style&index=0&id=9a53db7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a53db7e",
  null
  
)

export default component.exports